var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"production-name"},[_c('router-link',{staticClass:"flexrow",attrs:{"title":_vm.productionInfo,"to":_vm.productionRoute}},[(_vm.withAvatar)?_c('div',{staticClass:"flexrow-item avatar has-text-centered",style:({
         background: _vm.getAvatarColor(_vm.project),
         width: _vm.size + 'px',
         height: _vm.size + 'px',
         'font-size': (_vm.size - 15) + 'px',
         'line-height': _vm.size + 'px'
       })},[(!_vm.project.has_avatar)?_c('span',[_vm._v(" "+_vm._s(_vm.generateAvatar(_vm.project))+" ")]):_c('img',{style:({
          width: _vm.size + 'px',
          height: _vm.size + 'px'
        }),attrs:{"src":_vm.getThumbnailPath(_vm.project)}})]):_vm._e(),(!_vm.onlyAvatar)?_c('span',{staticClass:"flexrow-item avatar-name"},[_vm._v(" "+_vm._s(_vm.project.name)+" ")]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }